import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { scrollToTranscript } from './scoring-utils';
import type { QuestionScoreRow } from './types';

interface InformationResultsProps {
  questions: QuestionScoreRow[];
}

export function InformationResults({ questions }: InformationResultsProps): React.ReactNode {
  const { t } = useTranslation();

  if (questions.length === 0) return null;

  return (
    <div className="flex flex-col gap-3">
      <h2 className="text-base font-semibold">{t('scoring.information')}</h2>
      <div className="flex flex-col gap-2">
        {questions.map((q) => (
          <div
            key={q.id}
            className="rounded-lg border border-border bg-card p-4 shadow-sm border-l-4 border-l-[var(--color-section-purple)]"
          >
            <p className="text-sm font-medium">{q.questionText}</p>
            {q.evidence && (
              <div className="mt-2">
                <p className="text-xs font-medium text-muted-foreground">
                  {t('scoring.candidateAnswer')}
                </p>
                <p className="mt-0.5 text-sm italic text-muted-foreground">
                  &ldquo;{q.evidence}&rdquo;
                </p>
              </div>
            )}
            <button
              type="button"
              onClick={() => {
                scrollToTranscript(q.questionId);
              }}
              className="mt-2 inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
            >
              <MessageSquare className="size-3" />
              {t('scoring.viewInTranscript')}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
